"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bacoli": {
    "0390d7b7": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "baia": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e377d3e": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "cappella": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b94074d1": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "cuma": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e996995": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "fusaro": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cebbdd06": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "miliscola": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9208f0e7": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "miseno": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b82442e8": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "skipSearch": false
    }],
    "torregaveta": [{
      "hkey": "4b926a1c",
      "slug": "bacoli",
      "name": "Bacoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;